import SharedTextButton from './sharedTextButton'

export default SharedTextButton